import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export const CategoryTiles = () => {
  const [cats, setCats] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  if (!cats.length) return null;

  return (
    <section className="py-20 md:py-28" data-testid="category-tiles">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="text-xs uppercase tracking-[0.5em] text-gold mb-4">Shop by Category</p>
          <h2 className="font-serif font-medium text-4xl sm:text-5xl text-zinc-900 tracking-tight">
            Find your <em className="text-gold">ritual</em>
          </h2>
        </motion.div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {cats.map((c, i) => (
            <motion.button
              key={c.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              onClick={() => navigate(`/shop?cat=${c.slug}`)}
              data-testid={`category-tile-${c.slug}`}
              className="group relative overflow-hidden text-left aspect-[4/5] bg-[#faf7f7]"
            >
              <img
                src={c.image}
                alt={c.name}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="font-serif text-2xl text-white">{c.name}</h3>
                <p className="text-[10px] uppercase tracking-[0.25em] text-white/70 mt-1.5">{c.count} products</p>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};
